export const WEB_PAGES_PATH_NAME = 'web-pages';

export const WEBPAGE_RELATED_ENDPOINTS_DEFAULT_LIMIT = 25;

export const WEBPAGE_RELATED_ENDPOINTS_MAX_LIMIT = 100;

export const FEATURE_RELATED_REQUESTS_DEFAULT_LIMIT = 10;

export const FEATURE_RELATED_REQUESTS_MAX_LIMIT = 50;

export const WEBPAGE_SCREENSHOT_MAX_SIZE_BYTES = 5 * 1024 * 1024;

export const WEBPAGE_SCREENSHOT_MIME_TYPES = [
  'image/png',
  'image/jpeg',
  'image/jpg',
] as const;
